import type { LabelType } from '../../common/customControls/getServiceLabel';
import { getServiceLabel } from '../../common/customControls/getServiceLabel';
import { ServiceCode } from '../../common/enums/serviceCode';

export function getServiceLabelForCancellingToastMessage(serviceCode: ServiceCode, labelType: LabelType) {
    let serviceLabel: string | undefined;
    switch (serviceCode) {
        case ServiceCode.GGZBther:
        case ServiceCode.GGZBtherTreat:
            serviceLabel = 'Begeleiding';
            break;
        case ServiceCode.GGZCf2f:
        case ServiceCode.GGZCg:
        case ServiceCode.GGZCmdo:
        case ServiceCode.GGZCt:
        case ServiceCode.GGZCtriage:
            serviceLabel = 'Consult';
            break;
        case ServiceCode.GGZOembl:
            serviceLabel =
                labelType === 'request' ? 'Aanvraag voor een onderzoek' : getServiceLabel(serviceCode, labelType);
            break;
        default:
            serviceLabel = getServiceLabel(serviceCode, labelType);
            break;
    }

    return serviceLabel;
}
